import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartLocationNo = createSelector(cartState, (cart) => cart?.locationNo);
